import React, { useEffect, ReactElement } from "react";
import { useAuth, useUser } from "@/app/providers";
import { Navigate, Outlet } from "react-router";
import { useMe } from "@/hooks";
import { LayoutSplashScreen } from "@/components";

/**
 * AcquireLogin Component
 * Acquires user login information and manages the authentication flow.
 * Displays a loading screen while verifying user authentication status.
 *
 * @returns The outlet for nested routes if authenticated, otherwise a redirect to login
 */
export function AcquireLogin(): ReactElement {
  useMe();

  const { isAuthenticated } = useAuth();
  const { user, isLoadingUser } = useUser();

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (isAuthenticated && !user) {
        window.location.reload();
      }
    }, 5000);

    // Clear interval when user is defined or authentication fails
    return () => clearInterval(intervalId);
  }, [isAuthenticated, user]);

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" />;
  }

  if (isLoadingUser) {
    return <LayoutSplashScreen />;
  }

  if (!user) {
    return <LayoutSplashScreen />;
  }

  return <Outlet />;
}
